// extracted by mini-css-extract-plugin
export default {"filterTag":"filterTag--gvfnS"};